import React, { Ref, useCallback, useEffect, useState } from 'react'
import useIsMounted from 'ismounted'

import { API } from 'lib/gravy'
import Select, { SelectProps } from 'components/ui/Select/Select'
import { PartnerRole } from 'types/models'

const PartnerRoleSelect = React.forwardRef(
  (props: SelectProps, ref: Ref<HTMLInputElement>): JSX.Element => {
    const [roles, setRoles] = useState<PartnerRole[]>()
    const isMounted = useIsMounted()

    const options = useCallback(() => {
      return roles.map((role) => {
        return { value: role.id, text: `${role.name}` }
      })
    }, roles)

    useEffect(() => {
      API.get('partner_roles').then((response) => {
        if (isMounted.current) {
          setRoles(response.data)
        }
      })
    }, [])

    if (!roles) {
      return <Select {...props} />
    }

    return (
      <div className="relative rounded-md shadow-sm w-full">
        <Select options={options()} {...props} ref={ref} />
      </div>
    )
  }
)

export default PartnerRoleSelect
